var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { useId } from '../hooks';
import { Text } from '../text';
import Radiomark from './radiomark';
import { inputStaticStyle, labelStaticStyle, wrapperStyle } from './styles';
function RadioInternal(_a, ref) {
    var ariaLabel = _a["aria-label"], _b = _a.checked, checked = _b === void 0 ? false : _b, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, restProps = __rest(_a, ['aria-label', "checked", "children", "disabled", "error", "inverted", "size"]);
    var _g = useFocusRing(), focusProps = _g.focusProps, isFocusVisible = _g.isFocusVisible;
    var radioId = "radio-".concat(useId());
    var hasChildren = children != null;
    return (_jsxs("div", __assign({ css: wrapperStyle({ disabled: disabled, inverted: inverted }) }, { children: [_jsx("input", __assign({}, mergeProps(focusProps, restProps), { ref: ref }, (hasChildren && { id: radioId }), { "aria-invalid": error, "aria-label": ariaLabel, checked: checked, css: inputStaticStyle, disabled: disabled, type: "radio" })), _jsx(Radiomark, __assign({}, { checked: checked, error: error, isFocusVisible: isFocusVisible })), hasChildren && (_jsx(Text, __assign({ as: "label", css: labelStaticStyle, htmlFor: radioId, size: size }, { children: children })))] })));
}
export default RadioInternal;
